import { useHandler } from "@redotech/react-util/hook";
import {
  OmsAvailableInventoryConditionStep,
  OmsCustomAttributeNumber1ConditionStep,
  OmsCustomAttributeNumber2ConditionStep,
  OmsCustomAttributeNumber3ConditionStep,
  OmsCustomerOrderCountConditionStep,
  OmsCustomNumber1ConditionStep,
  OmsCustomNumber2ConditionStep,
  OmsCustomNumber3ConditionStep,
  OmsDestinationForecastTemperatureConditionStep,
  OmsItemAmountConditionStep,
  OmsItemQuantityConditionStep,
  OmsPackageWeightOzConditionStep,
  OmsProductCustomNumber1ConditionStep,
  OmsProductCustomNumber2ConditionStep,
  OmsProductCustomNumber3ConditionStep,
  OmsTaxesPaidConditionStep,
  OmsTotalValueConditionStep,
} from "@redotech/redo-flows-common/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-flows-common/steps";
import {
  NumberComparisonOperator,
  numberComparisonOperators,
} from "@redotech/redo-flows-core-common/comparison-operators";
import { numberComparisonToLabel } from "@redotech/redo-flows-core-schema-common/expressions/number-expression";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { memo } from "react";
import { DeepPartial } from "..";
import { NumberMatchKindSelect } from "../common/number-match-kind-select";

const numericCompareOptions: RedoListItem<NumberComparisonOperator>[] =
  numberComparisonOperators.map((type) => ({
    value: type,
    type: "text",
    id: type,
    text: numberComparisonToLabel[type],
  }));

export const OmsNumberMatchTypeSelect = memo(function NumberMatchTypeSelect({
  step,
  setStep,
}: {
  step:
    | DeepPartial<OmsTotalValueConditionStep>
    | DeepPartial<OmsTaxesPaidConditionStep>
    | DeepPartial<OmsPackageWeightOzConditionStep>
    | DeepPartial<OmsItemQuantityConditionStep>
    | DeepPartial<OmsItemAmountConditionStep>
    | DeepPartial<OmsAvailableInventoryConditionStep>
    | DeepPartial<OmsCustomNumber1ConditionStep>
    | DeepPartial<OmsCustomNumber2ConditionStep>
    | DeepPartial<OmsCustomNumber3ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber1ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber2ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber3ConditionStep>
    | DeepPartial<OmsCustomerOrderCountConditionStep>
    | DeepPartial<OmsProductCustomNumber1ConditionStep>
    | DeepPartial<OmsProductCustomNumber2ConditionStep>
    | DeepPartial<OmsProductCustomNumber3ConditionStep>
    | DeepPartial<OmsDestinationForecastTemperatureConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
}) {
  const setMatchType = useHandler((item: NumberComparisonOperator) => {
    setStep({ ...step, matchType: item });
  });
  return (
    <NumberMatchKindSelect<NumberComparisonOperator>
      options={numericCompareOptions}
      selectedMatchKind={
        numericCompareOptions.find((o) => o.id === step.matchType)?.value
      }
      setMatchKind={setMatchType}
    />
  );
});
